import "./singleCharacter.scss";

const SingleCharacter = ({ data }) => {
    const { name, description, thumbnail } = data;

    return (
        <div className="singleCharacter__wrapper">
            <img src={thumbnail} alt="ghj" className="singleCharacter__img" />
            <div className="singleCharacter__content">
                <div className="singleCharacter__content-title">
                    <h3 className="singleCharacter__content-title-first">
                        {name}
                    </h3>
                    <p className="singleCharacter__content-text">
                        {description}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default SingleCharacter;

// const SingleCharacter = () => {
//     const { characterId } = useParams(); //т.к. хук возвращает  объект {cimicId:56}, то этот ключ можно вытащить путем деструктуризации
//     const [character, setCharacter] = useState(null);

//     const { error, loading, getCharacter, clearError } = useMarvelService();

//     useEffect(() => {
//         upDateCharacter();
//     }, [characterId]);

//     const upDateCharacter = () => {
//         clearError(); //перед тем как делаем новый запрос убираем ошибку
//         getCharacter(characterId).then(onCharacterLoaded);
//     };

//     const onCharacterLoaded = (character) => {
//         setCharacter(character);
//     };

//     const errorMessage = error ? <ErrorMessage /> : null;
//     const spinner = loading ? <Spinner /> : null;

//     const content = !(loading || error || !character) ? (
//         <div className="singleCharacter__wrapper">
//             <img
//                 src={character.thumbnail}
//                 alt="ghj"
//                 className="singleCharacter__img"
//             />
//             <div className="singleCharacter__content">
//                 <div className="singleCharacter__content-title">
//                     <h3 className="singleCharacter__content-title-first">
//                         {character.name}
//                     </h3>
//                     <p className="singleCharacter__content-text">
//                         {character.description}
//                     </p>
//                 </div>
//             </div>
//         </div>
//     ) : null;

//     return (
//         <section className="singleCharacter">
//             {errorMessage}
//             {spinner}
//             {content}
//         </section>
//     );
// };

// export default SingleCharacter;
